export { default as SupportingText } from './SupportingText';
export { supportingTextAdapter } from './adapters';
